import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import Image from '~/components/Shared/Image/Image';
import { getImagePathAndExtension } from '~/utilities/getImagePathAndExtension';

interface BackgroundImageInterface {
  backgroundImage: string;
  alt?: string;
}

export default component$<BackgroundImageInterface>(
  ({ backgroundImage, alt }): JSX.Element => {
    const { path, extension } = getImagePathAndExtension(backgroundImage);
    return (
      <Image
        aspectRatio={'original'}
        imageWidths={{ small: 719, medium: 1000, large: 1800 }}
        alt={alt}
        loading='lazy'
        imageClass='object-cover h-full'
        wrapperClass='absolute top-0 left-0 w-full h-full'
        path={path}
        fileExtension={extension}
      />
    );
  }
);
